// extracted by mini-css-extract-plugin
export var avatar = "discord-widget-module--avatar--4697a";
export var discordWidget = "discord-widget-module--discordWidget--a7b57";
export var discordWrapper = "discord-widget-module--discordWrapper--56bf5";
export var flex = "discord-widget-module--flex--025e4";
export var game = "discord-widget-module--game--a1ac6";
export var idle = "discord-widget-module--idle--dcc52";
export var imageWrapper = "discord-widget-module--imageWrapper--9104d";
export var muteWrapper = "discord-widget-module--muteWrapper--56bf8";
export var mutedButton = "discord-widget-module--mutedButton--7b955";
export var online = "discord-widget-module--online--ce4df";
export var playButton = "discord-widget-module--playButton--87b78";
export var toggleButton = "discord-widget-module--toggleButton--e7489";
export var userName = "discord-widget-module--userName--4dc6f";
export var userWrapper = "discord-widget-module--userWrapper--26674";